import { useApp } from '@libs/core';
import { CoreButtonView, type TCoreButtonStyleProps, type TCoreButtonViewProps } from '@core/widgets';
import React from 'react';

type TCalculatorFeeButtonProps = {
    enterCodePopup: React.ReactNode;
    appliedCodePopup: React.ReactNode;
    handlingAutoApplied?: boolean;
    label: string;
    value?: string;
    parentStyleNames?: string[];
};

const codeButtonStyleProps: TCoreButtonStyleProps = {
    variant: 'outlined',
    surface: 'var(--color-white)',
    main: 'var(--color-purple_100)',
    borderRadius: 16,
    borderStroke: 1,
    outline: 'var(--color-grey_16_lc)',
    fontStyle: { fontWeight: 500, fontSize: 14, lineHeight: 20 },
    padding: { top: 4, right: 16, bottom: 4, left: 16 },
    hovered: { surface: 'var(--color-purple_16_lc)', outline: 'var(--color-grey_16_lc)', main: 'var(--color-purple_100)' },
    pressed: { surface: 'var(--color-purple_8_lc)', outline: 'var(--color-grey_16_lc)', main: 'var(--color-purple_100)' },
};

const CodeButton = React.memo(({ enterCodePopup, appliedCodePopup, label, value, handlingAutoApplied, parentStyleNames }: TCalculatorFeeButtonProps) => {
    const { setPopup } = useApp();
    const handleClick = () => {
        setPopup(value || handlingAutoApplied ? appliedCodePopup : enterCodePopup);
    };
    const widget = { uid: '', data: { text: label }, options: {} } as TCoreButtonViewProps['widget'];
    return (
        <CoreButtonView
            widget={widget}
            text={label}
            styleName="calculatorCodeButton"
            parentStyleNames={parentStyleNames}
            styleProps={codeButtonStyleProps}
            onClick={handleClick}
        />
    );
});
export { CodeButton };
